export type AdminLevel = 'SUPER_ADMIN' | 'RESTRICTED_ADMIN';

export interface AdminUser {
  id: string;
  name: string;
  email: string;
  adminLevel: AdminLevel;
  adminCategories: string[];
  createdAt: string;
  status: 'active' | 'suspended';
}

export interface AdminActivity {
  id: string;
  adminId: string;
  adminName: string;
  action: string;
  details: string;
  timestamp: string;
}

const defaultAdmins: AdminUser[] = [
  {
    id: "admin-1",
    name: "Super Admin",
    email: "admin@kaynin.com",
    adminLevel: "SUPER_ADMIN",
    adminCategories: [], // All access
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    status: "active"
  },
  {
    id: "admin-2",
    name: "Éditeur Contenu",
    email: "editeur@kaynin.com",
    adminLevel: "RESTRICTED_ADMIN",
    adminCategories: ["Contenu & Apparence"],
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    status: "active"
  },
  {
    id: "admin-3",
    name: "Modérateur Débats",
    email: "moderateur@kaynin.com",
    adminLevel: "RESTRICTED_ADMIN",
    adminCategories: ["Participation Citoyenne", "Média & Communication"],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    status: "active"
  }
];

const defaultActivities: AdminActivity[] = [
  {
    id: "act-1",
    adminId: "admin-2",
    adminName: "Éditeur Contenu",
    action: "Modification Page",
    details: "Mise à jour des mentions légales",
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: "act-2",
    adminId: "admin-3",
    adminName: "Modérateur Débats",
    action: "Validation Débat",
    details: "Approuvé le sujet de débat #45",
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: "act-3",
    adminId: "admin-1",
    adminName: "Super Admin",
    action: "Création Admin",
    details: "A créé le compte de Modérateur Débats",
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString()
  }
];

export function getAdmins(): AdminUser[] {
  const data = localStorage.getItem('kaynin_admins');
  return data ? JSON.parse(data) : defaultAdmins;
}

export function saveAdmins(admins: AdminUser[]) {
  localStorage.setItem('kaynin_admins', JSON.stringify(admins));
}

export function addAdmin(admin: AdminUser) {
  const admins = getAdmins();
  saveAdmins([...admins, admin]);
}

export function updateAdmin(id: string, updates: Partial<AdminUser>) {
  const admins = getAdmins();
  const index = admins.findIndex(a => a.id === id);
  if (index !== -1) {
    admins[index] = { ...admins[index], ...updates };
    saveAdmins(admins);
  }
}

export function removeAdmin(id: string) {
  const admins = getAdmins();
  saveAdmins(admins.filter(a => a.id !== id));
}

export function getActivities(): AdminActivity[] {
  const data = localStorage.getItem('kaynin_admin_activities');
  return data ? JSON.parse(data) : defaultActivities;
}

export function saveActivities(activities: AdminActivity[]) {
  localStorage.setItem('kaynin_admin_activities', JSON.stringify(activities));
}

export function logAdminActivity(adminId: string, adminName: string, action: string, details: string) {
  const activities = getActivities();
  const newActivity: AdminActivity = {
    id: `act-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
    adminId,
    adminName,
    action,
    details,
    timestamp: new Date().toISOString()
  };
  saveActivities([newActivity, ...activities]);
}
